// Account menu expandable.
import {
  isExpanded,
  expandCollapse,
  handleClickOutside,
} from '../utils/expandCollapse';

// As per Drupal coding standards all code must be inside closure.
(() => {
  const initMenu = (menu) => {
    const mainLink = menu.querySelector('.account-link--logged-in');

    // If the user is logged in, we attach click listener to expand/collapse dropdown.
    if (mainLink) {
      const dropdown = menu.querySelector('.account-links__dropdown');
      const arrowIcon = menu.querySelector('.fa-angle-down');

      mainLink.addEventListener('click', () => {
        // The actual expanding/collapsing is handled by the util.
        expandCollapse(dropdown, mainLink);
        const state = isExpanded(dropdown);
        // Rotate the icon.
        arrowIcon.style.transform = `scaleY(${state ? -1 : 1})`;
      });

      handleClickOutside(dropdown, [mainLink], () => {
        // Callback with actions after collapsing.
        arrowIcon.style.transform = 'scaleY(1)';
      });

      // Todo: make DRYer, debounce scroll listener.
      window.addEventListener('scroll', () => {
        if (window.scrollY > 150 && isExpanded(dropdown)) {
          expandCollapse(dropdown);
          arrowIcon.style.transform = 'scaleY(1)';
        }
      });
    }
  };

  const accountMenus = [...document.querySelectorAll('.account-links')];

  if (accountMenus.length) {
    accountMenus.forEach((menu) => {
      initMenu(menu);
    });
  }
})();
